module.exports = __webpack_public_path__ + "img/list_2_tc.02f7cbcb.png";